<template>
  <div
    :key="'btn-twitter' + componentKey"
    class="btn-twitter" >
    <a
      :data-lang="lang.params.toLowerCase()"
      href="https://twitter.com/share?ref_src=twsrc%5Etfw"
      class="twitter-share-button"
      data-text="ミュージアム展示ガイドアプリ「ポケット学芸員」"
      data-url="http://welcome.mapps.ne.jp/pocket"
      data-show-count="false" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'BtnTwitter',
  components: {
    mapGetters
  },
  data () {
    return {
      componentKey: 0
    }
  },
  computed: {
    ...mapGetters(['textData', 'lang'])
  },
  methods: {
    createScript: function () {
      let elem = document.getElementById('tweeter-widgets')
      console.log('elem:', elem)
      if (elem) elem.remove()
      // ツイートボタン用のJSを作成
      let tweetScript = document.createElement('script')
      tweetScript.id = 'tweeter-widgets'
      tweetScript.async = true
      tweetScript.setAttribute('src', 'https://platform.twitter.com/widgets.js')
      document.querySelector('.btn-twitter').appendChild(tweetScript)
    }
  },
  mounted () {
    this.createScript()
  },
  updated () {
    this.createScript()
  },
  created () {
  },
  watch: {
    'lang': function () {
      console.log('watch2', this.lang)
      this.componentKey++
    }
  }
}
</script>

<style lang="postcss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/atoms/BtnTwitter.vue